export class ServiceResult {
    constructor(
        public message: string,
        public error: any,
        public hasError: boolean,
        public refrenceId: string,
    ) {
    }
}